const helpActionTypes = {
    CREATE_TICKET: 'help/CREATE_TICKET',
    CREATING_TICKET: 'help/CREATING_TICKET',
    CREATED_TICKET: 'help/CREATED_TICKET',
    UPLOAD_USER_FILE: 'help/UPLOAD_USER_FILE',
    UPLOADING_USER_FILE: 'help/UPLOADING_USER_FILE',
    UPLOADED_USER_FILE: 'help/UPLOADED_USER_FILE',
    LOAD_MGMT_GRPS: 'help/LOAD_MGMT_GRPS',
    LOADING_MGMT_GRPS: 'help/LOADING_MGMT_GRPS',
    LOADED_MGMT_GRPS: 'help/LOADED_MGMT_GRPS',
    LOAD_FLIGHT_DATA: 'help/LOAD_FLIGHT_DATA',
    LOADING_FLIGHT_DATA: 'help/LOADING_FLIGHT_DATA',
    LOADED_FLIGHT_DATA: 'help/LOADED_FLIGHT_DATA',
    DELETE_FLIGHT: 'help/DELETE_FLIGHT',
    DELETING_FLIGHT: 'help/DELETING_FLIGHT',
    DELETED_FLIGHT: 'help/DELETED_FLIGHT',
    LOAD_MDS_FLIGHT_CONTROL: 'help/LOAD_MDS_FLIGHT_CONTROL',
    LOADING_MDS_FLIGHT_CONTROL: 'help/LOADING_MDS_FLIGHT_CONTROL',
    LOADED_MDS_FLIGHT_CONTROL: 'help/LOADED_MDS_FLIGHT_CONTROL',
    CHANGE_MG: 'help/CHANGE_MG',
    CHANGING_MG: 'help/CHANGING_MG',
    CHANGED_MG: 'help/CHANGED_MG',
    LOAD_CATEGORIES: 'help/LOAD_CATEGORIES',
    LOADING_CATEGORIES: 'help/LOADING_CATEGORIES',
    LOADED_CATEGORIES: 'help/LOADED_CATEGORIES',
    CLEAR_UPLOADED_FILE_CACHE: 'help/CLEAR_UPLOADED_FILE_CACHE',
};
export default helpActionTypes;

//# sourceMappingURL=HelpActionTypes.js.map
